module.exports = __webpack_public_path__ + "img/manda_027.07fed8fa.png";